import React from 'react';

const Toast = ({ message, type = 'success' }) => {
    // Truncate long messages
    const truncatedMessage = message.length > 50 
        ? message.substring(0, 47) + '...' 
        : message;

    return (
        <div style={{
            position: 'fixed',
            bottom: '80px',  // Position above the toolbar
            left: '50%',
            transform: 'translateX(-50%)',
            background: type === 'success' ? '#4a86e8' : '#ff4444',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '100px',
            boxShadow: type === 'success' 
                ? '0 4px 12px rgba(74, 134, 232, 0.2)'
                : '0 4px 12px rgba(255, 68, 68, 0.2)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '14px',
            fontWeight: '500',
            zIndex: 1100,
            animation: 'slideUp 0.3s ease-out',
            maxWidth: '80vw',  // Prevent toast from being too wide
        }}>
            {type === 'success' ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 6L9 17l-5-5"/>
                </svg>
            ) : (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="15" y1="9" x2="9" y2="15"/>
                    <line x1="9" y1="9" x2="15" y2="15"/>
                </svg>
            )}
            {truncatedMessage}
        </div>
    );
};

export default Toast; 